import { useMutation } from "@tanstack/react-query";

import { CONSOLE_API_ROUTES } from "@/config/apiConfig";
import consoleAxios from "@/service/axios/consoleAxios";

interface body {
    p_type: string;
    p_open: string;
    p_title: string;
    p_s_date: string;
    p_e_date: string;
    p_one_day: string;
    p_layer_pop: string;
    p_width_size: number;
    p_height_size: number;
    p_left_point: number;
    p_top_point: number;
    p_scroll: string;
    p_link_target: string;
    p_link_url: string;
    p_content: string;
    p_lang: string;
}

// 팝업 등록
export const usePostPopupCreate = () => {
    return useMutation({
        mutationFn: async (body: body) => {
            const res = await consoleAxios.post(CONSOLE_API_ROUTES.POPUP, body);
            return res.data;
        },
    });
};
